import { useMemo } from 'react';

export const useGameCardSize = (width?: number, columns?: number, gap?: number) => {
  return useMemo(() => getGameCardSize({ width, columns, gap }), [columns, gap, width]);
};

interface getGameCardFontSizeParam {
  width?: number;
  columns?: number;
  gap?: number;
}

const getGameCardSize = ({ width, columns, gap = 8 }: getGameCardFontSizeParam) => {
  const breakpointObj: { [key: string]: boolean } = {
    is90: false,
    // is100: false,
    is110: false,
    // is120: false,
    is130: false,
    is140: false,
    is150: false
  };
  if (!width || !columns) return breakpointObj;
  const singlCardWidth = Math.round((width - gap * (columns - 1)) / columns);
  for (const breakpoint in breakpointObj) {
    breakpointObj[breakpoint] = Number(breakpoint.slice(2)) < singlCardWidth;
  }
  return breakpointObj;
};
